import DiagnosticLeadsTable from '../../components/DiagnosticLeadsTable';

export default function MarketingLeadsPage() {
  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8 lg:p-10">
      <div className="mx-auto max-w-7xl">
        <DiagnosticLeadsTable type="marketing" />
      </div>
    </div>
  );
}
